import { useState, useEffect } from 'react';
import Close from '../assets/images/howtoplay/carousel/close.png';
import './Popup.css';
import moment from 'moment';

const Popup = ({ onClose }) => {
    const [inputState, setInputState] = useState("");
    const [hasSubmitted, setHasSubmitted] = useState(false);
    const [requestedCode, setRequestedCode] = useState("");

    const [status, setStatus] = useState({
        message: "",
        type: "",
        enableGenerateButton: false,
        enableGetButton: true,
    });

    const [expirationDate, setExpirationDate] = useState(null);
    const [countdown, setCountdown] = useState("");

    useEffect(() => {
        if (!expirationDate) return;

        const interval = setInterval(() => {
            const now = moment();
            const duration = moment.duration(moment(expirationDate).diff(now));

            if (duration.asMilliseconds() <= 0) {
                clearInterval(interval);
                setCountdown("00:00");
                return;
            }
            const formatted = moment.utc(duration.asMilliseconds()).format("mm:ss");
            setCountdown(formatted);
        }, 1000);

        return () => clearInterval(interval);
    }, [expirationDate]);

    const formatCode = (code) => {
        return `${code.slice(0, 4)}-${code.slice(4, 8)}-${code.slice(8, 12)}-${code.slice(12, 14)}`;
    };

    const handleSubmit = async (requestType) => {
        setHasSubmitted(true);
        const apiUrl = process.env.REACT_APP_API_URL;
        if (!inputState) {
            setStatus((prev) => ({
                ...prev,
                message: "The input is required.",
                type: "ERROR",
            }));
            setHasSubmitted(false);
            return;
        }
        try {
            let body = null;

            if (requestType === "GET_CODE") {
                body = JSON.stringify({ shortId: Number(inputState) });
            }
            if (requestType === "GENERATE_CODE") {
                body = JSON.stringify({ shortId: Number(inputState), newCode: true });
            }

            const response = await fetch(`${apiUrl}/get-random-code`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: body,
            });

            if (response) {
                const data = await response.json();
                if (data.status === 200) {
                    if (data.payload.status === "GENERATION_IN_PROGRESS") {
                        setExpirationDate(data.payload.generationDate); // start countdown

                        setStatus({
                            message: "The code generation is in progress.",
                            type: data.payload.status,
                            enableGenerateButton: false,
                            enableGetButton: true,
                        });
                        return;
                    }
                    if (data.payload.status === "SUCCESS") {
                        const code = formatCode(data.payload.code);
                        setRequestedCode(code);
                        setStatus({
                            message: "",
                            type: data.payload.status,
                            enableGenerateButton: true,
                            enableGetButton: false,
                        });
                        return;
                    }
                } else {
                    if (data.payload.errorMessage === "No pending or active code found. Please request a new one.") {
                        setStatus({
                            message: data.payload.errorMessage,
                            type: data.payload.status,
                            enableGenerateButton: true,
                        });
                    } else {
                        setStatus({
                            message: data.payload.errorMessage,
                            type: data.payload.status,
                            enableGenerateButton: false,
                            enableGetButton: true,
                        });

                    }
                }
            }
        } catch (error) {
            console.debug(error.message);
            setStatus({
                message: error.message,
                type: "ERROR",
                enableGenerateButton: false,
                enableGetButton: true,
            });
        } finally {
            setHasSubmitted(false);
        }
    };

    const stateReset = () => {
        setStatus({
            message: "",
            type: "",
            enableGenerateButton: false,
            enableGetButton: true,
        });
        setExpirationDate(null);
        setCountdown("");
        if (requestedCode) {
            setRequestedCode("");
        }
    };

    const handleInputChange = (e) => {
        setInputState(e.target.value);
        stateReset();
    };

    return (
        <div className="popup-overlay">
            <div className="popup-content">
                <button className="popup-close-btn" onClick={onClose}>
                    <img src={Close} alt="close-button" />
                </button>
                <h2 className="popup-title">Postal Request</h2>
                <p className="popup-description">
                    Postal Request Codes for SOPO Sweepstakes participation may be requested once
                    every 15 minutes.
                </p>
                <div className="input-container">
                    <h3 className="popup-subtitle">SOPO Short ID</h3>
                    <input
                        value={inputState}
                        onChange={handleInputChange}
                        name="short-id"
                        id="short-id"
                    />
                    <p className="input-description">
                        You can find your short ID under your username in the Profile page of the
                        app.
                    </p>
                    {status.type === "ERROR" && <p className="error-message">{status.message}</p>}
                    {status.type === "SUCCESS" && (
                        <>
                            {status.message && <p className="success-message">{status.message}</p>}
                            {requestedCode && (
                                <div className="code-container">
                                    <p className="code-description">Your unique Postal Request Code</p>
                                    <p className="code">{requestedCode}</p>
                                </div>
                            )}
                        </>
                    )}
                    {status.type === "GENERATION_IN_PROGRESS" && (
                        <p className="success-message">
                            {status.message} Time left: <strong>{countdown}</strong>
                        </p>
                    )}
                </div>
                <button
                    className={`popup-btn ${hasSubmitted || !status.enableGetButton ? "blue-btn" : "green-btn"}`}
                    onClick={() => handleSubmit("GET_CODE")}
                    disabled={hasSubmitted || !status.enableGetButton}
                >
                    Get Code
                </button>
                <button
                    className={`popup-btn ${!status.enableGenerateButton ? "blue-btn" : "green-btn"}`}
                    onClick={() => handleSubmit("GENERATE_CODE")}
                    disabled={!status.enableGenerateButton || hasSubmitted}
                >
                    Generate Code
                </button>
            </div>
        </div>
    );
};

export default Popup;
